import request from '@/utils/request'

export function event(data) {
  return request({
    url: '/tracking/event',
    method: 'post',
    data
  })
}



// WEBPACK FOOTER //
// ./src/api/app.js